import { action } from '@ember/object';
import type Owner from '@ember/owner';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import FormInputSearchComponent from 'webapp/components/form/input-search';
import FormSelectComponent from 'webapp/components/form/select';
import type { OptionRaw } from 'webapp/components/form/select';

interface BrowseTypeConfig {
	title: string;
	description: string;
	imgSrc: string;
	placeholder: string;
}

interface BrowseTypeMap {
	SOURCE: BrowseTypeConfig;
	CATEGORY: BrowseTypeConfig;
}

const browseType: BrowseTypeMap = {
	SOURCE: {
		title: 'Browse by data source',
		description: 'We have 70+ one-click integrations waiting for you to choose from.',
		imgSrc: '/images/placeholders/metrics3.png',
		placeholder: 'Select a data source',
	},
	CATEGORY: {
		title: 'Browse by category',
		description: '',
		imgSrc: '/images/placeholders/metrics4.png',
		placeholder: 'Select a category',
	},
};

interface Args {
	searchTypedFilter: string; // to get filter sort text
	changeSearch: (value: string) => void; // to trigger search text update
	hideBrowse?: boolean; // hide browser

	// When @hideBrowse is false below props are used
	browseSelected: string | null; // selected id on select
	browseOptions: OptionRaw<string>[]; // select options
	onBrowseChange: (value: string) => void; // to trigger select change
	browseName: string; // add name attribute to select
	browseBy?: 'source' | 'category';
}

export default class SearchBrowseBannerComponent extends Component<Args> {
	@tracked browseTypeObj: BrowseTypeConfig | null = null;

	constructor(owner: Owner, args: Args) {
		super(owner, args);

		const browseBy = this.args.browseBy?.toUpperCase() || 'SOURCE';
		this.browseTypeObj = browseType[browseBy as keyof BrowseTypeMap];
	}

	@action
	changeBrowseSelected(value: string | null) {
		this.args.onBrowseChange(value!);
	}
	<template>
		<div id="search-browse-banner" class="smaller">
			<div class="search">
				<div class="img">
					<img src="/images/placeholders/metrics2.png" alt />
				</div>
				<div class="desc">
					<div class="title">Search</div>

					<div class="filter-line">
						<FormInputSearchComponent
							@value={{@searchTypedFilter}}
							@onChange={{@changeSearch}}
							@size="small"
						/>
					</div>
				</div>
			</div>

			{{#unless @hideBrowse}}
				<div class="browse">
					<div class="img">
						<img src={{this.browseTypeObj.imgSrc}} alt />
					</div>
					<div class="desc">
						<div class="title">{{this.browseTypeObj.title}}</div>

						<div class="filter-line">
							<FormSelectComponent
								name={{@browseName}}
								@selected={{@browseSelected}}
								@options={{@browseOptions}}
								@onChange={{this.changeBrowseSelected}}
								@isNumeric={{false}}
								@placeholder={{this.browseTypeObj.placeholder}}
								@isRequired={{true}}
								@showFloatlabel={{false}}
							/>
						</div>
					</div>
				</div>
			{{/unless}}
		</div>
	</template>
}
